import { TimeStr } from '@csp/csp-common-model';

export type TimeOfDay = {
  dayIndex: number;
  time: TimeStr;
};

const from = (dayIndex: number, time: TimeStr): TimeOfDay => ({
  dayIndex,
  time,
});

export const TimeOfDay = {
  from,
};
